import browserModeProcessor from 'HHC/CheckBrowser/BrowserMode/BrowserModeProcessor';
import checkLocalStorageChange from 'HHC/CheckBrowser/HHUID/checkLocalStorageChange';

export default () => {
    browserModeProcessor();
    checkLocalStorageChange();
};
